// Lib
import React from 'react';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';

// Components
import ApprovalShipmentMethodLabel from '../../../../Labels/ApprovalShipmentMethodLabel';

const InfoCardShippingMethod = ({
  orderDetails,
  isMobileMode,
  userWithoutAllLimits,
  classes,
}) => {
  const showApproval =
    orderDetails.shipment_method.escalation && !userWithoutAllLimits;

  return (
    <Box
      className={classes.shippingMethod}
      display="flex"
      flexDirection="column">
      <Typography className={classes.orderInfoHeader}>
        Shipping Method{isMobileMode && ':'}
      </Typography>
      <Typography className={classes.orderInfoText}>
        {orderDetails.shipment_method?.name || '-'}
      </Typography>
      {/* escalation shows is approve needed or not */}
      {showApproval && (
        <ApprovalShipmentMethodLabel
          approval={orderDetails.approval}
          requestedMethod={orderDetails.requested_shipment_method_name}
          approvedMethod={orderDetails.shipment_method.name}
          data-testid="approval-shipment-method-label"
        />
      )}
    </Box>
  );
};

export default InfoCardShippingMethod;
